import { Mail, MapPin } from 'lucide-react';
import SEO from '@/components/SEO';
import MarketingHeader from '@/components/layout/MarketingHeader';
import MarketingFooter from '@/components/layout/MarketingFooter';

const ContactPage = () => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    name: 'Contact Review Plum',
    description: 'Get in touch with Review Plum for questions about our AI-powered Google review generation platform.',
    url: 'https://reviewplum.com/contact',
    mainEntity: {
      '@type': 'Organization',
      name: 'Review Plum',
      email: 'arpit@reviewplum.com',
      url: 'https://reviewplum.com',
    },
  };

  return (
    <>
      <SEO
        title="Contact Us - Review Plum | Get in Touch"
        description="Have questions about Review Plum? Contact us for support, partnerships, or general inquiries. We're here to help you grow your business with AI-powered reviews."
        keywords={['contact review plum', 'customer support', 'review generation help', 'business inquiries']}
        canonicalUrl="https://reviewplum.com/contact"
        jsonLd={jsonLd}
      />
      
      <div className="min-h-screen bg-background">
        <MarketingHeader />
        
        <main className="container mx-auto px-4 py-16 max-w-4xl">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
              Get in Touch
            </h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Have questions about Review Plum? We'd love to hear from you. Reach out to us and we'll respond within 24-48 hours.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-2xl mx-auto">
            <div className="bg-card border border-border rounded-2xl p-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Mail className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-foreground mb-2">Email Us</h2>
                  <a 
                    href="mailto:arpit@reviewplum.com" 
                    className="text-muted-foreground hover:text-primary transition-colors"
                  >
                    arpit@reviewplum.com
                  </a>
                  <p className="text-sm text-muted-foreground mt-2">
                    For support, partnerships, or general inquiries
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-card border border-border rounded-2xl p-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-foreground mb-2">Location</h2>
                  <p className="text-muted-foreground">
                    Bangalore, India
                  </p>
                  <p className="text-sm text-muted-foreground mt-2">
                    Serving businesses worldwide
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 p-6 bg-muted/50 rounded-xl max-w-2xl mx-auto text-center">
            <h3 className="font-semibold text-foreground mb-3">
              Why Reach Out?
            </h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>• Questions about our platform</li>
              <li>• Pricing and enterprise plans</li>
              <li>• Technical support</li>
              <li>• Partnership opportunities</li>
              <li>• Feature requests</li>
            </ul>
          </div>
        </main>
        
        <MarketingFooter />
      </div>
    </>
  );
};

export default ContactPage;
